import { ClientStatus } from '../types'
import { NAVIGATION_COPY } from '@/locales/en'

const statusConfig: Record<
    ClientStatus,
    {
        bgColor: string
        dotColor: string
        textColor: string
        progressDots: number
        label: string
    }
> = {
    [ClientStatus.KYC_IN_PROGRESS]: {
        bgColor: 'bg-yellow-100',
        dotColor: 'bg-content-tertiary',
        textColor: 'text-black',
        progressDots: 1,
        label: NAVIGATION_COPY.adviserClients.status.kycInProgress,
    },
    [ClientStatus.CONFIRMATION_FAILED]: {
        bgColor: 'bg-red-100',
        dotColor: 'bg-content-tertiary',
        textColor: 'text-black',
        progressDots: 1,
        label: NAVIGATION_COPY.adviserClients.status.kycFailed,
    },
    [ClientStatus.CLIENT_CONFIRMATION]: {
        bgColor: 'bg-emerald-100',
        dotColor: 'bg-content-tertiary',
        textColor: 'text-black',
        progressDots: 2,
        label: NAVIGATION_COPY.adviserClients.status.clientConfirmation,
    },
    [ClientStatus.ACCOUNT_PROCESSING]: {
        bgColor: 'bg-brand-primary-emerald',
        dotColor: 'bg-white',
        textColor: 'text-white',
        progressDots: 3,
        label: NAVIGATION_COPY.adviserClients.status.accountProcessing,
    },
}

export type ClientStatusBadgeProps = {
    status: ClientStatus
}

export function ClientStatusBadge({ status }: ClientStatusBadgeProps) {
    const config = statusConfig[status]

    return (
        <div
            className={`px-3 py-1.5 ${config.bgColor} rounded-2xl backdrop-blur-[5px] inline-flex justify-start items-center gap-2 overflow-hidden`}
        >
            <div className="flex justify-start items-center gap-1">
                {[1, 2, 3].map((dotIndex) => (
                    <div
                        key={dotIndex}
                        className={`w-2 h-2 relative rounded-[100px] ${
                            dotIndex <= config.progressDots ? config.dotColor : 'opacity-25 bg-content-secondary'
                        }`}
                    />
                ))}
            </div>
            <div className={`justify-center ${config.textColor} text-xs font-medium font-['Inter'] leading-4`}>
                {config.label}
            </div>
        </div>
    )
}
